import type { SVGProps } from "react";

// LDF: Blumenstrauß als Icon im Stil der übrigen Linien-Icons (24×24, currentColor):
// drei Blüten, zusammengebundene Stiele mit Schleife und Blättern
export const BouquetIcon = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <circle cx="6.5" cy="6" r="2.3" />
    <circle cx="17.5" cy="6" r="2.3" />
    <circle cx="12" cy="3.8" r="2.3" />
    <path d="M7.6 8.1 11.2 14.5M16.4 8.1 12.8 14.5M12 6.1v8.4" />
    <path d="M11.2 14.5 9 21.5M12 14.5v7M12.8 14.5 15 21.5" />
    <path d="M9.8 14.6c-1.1-1-2.6-1.1-3.5-.4.9.9 2.4 1.1 3.5.4zM14.2 14.6c1.1-1 2.6-1.1 3.5-.4-.9.9-2.4 1.1-3.5.4z" />
    <path d="M5.6 10.8c1.5-.6 3-.2 3.8.9-1.5.6-3 .2-3.8-.9zM18.4 10.8c-1.5-.6-3-.2-3.8.9 1.5.6 3 .2 3.8-.9z" />
  </svg>
);
